/**
 *               .__               
 *  ___  __ ____ |__| ______ ______
 *  \  \/ // __ \|  |/  ___//  ___/
 *   \   /\  ___/|  |\___ \ \___ \ 
 *    \_/  \___  >__/____  >____  >
 *             \/        \/     \/ 
 *
 *  Client for handle http requests in JS apps
 *  Uses Axios for the requests
 *  iban@veiss.com
 * 
 */

import axios from 'axios'

/**
 * Create an axios instance
 * 
 */

const url = process.env.VUE_APP_API_URL

const httpClient = axios.create({
    baseURL: `${url}`,
    timeout: 5000,
});

/**
 * Axios Interceptor to add the token in every request
 * 
 * @param config Object
 * 
 */

const authInterceptor = async (config) => {

    let token = await getAuthToken

    config.headers['Authorization'] = `Bearer ${token}`
    return config

}

/**
 * Get the JWT token from the API
 * 
 */

const TOKEN_END_POINT = '/authentication_token'

const getAuthToken = new Promise((resolve,reject) => {

    httpClient.post( TOKEN_END_POINT, {

        "username": process.env.VUE_APP_API_USER,
        "password": process.env.VUE_APP_API_PASSWORD

    })
    .then((res) => {

        if(res.status == 200) {

           resolve(res.data.token)

        }

    })
    .catch((error) => {

        reject(error)

    })

})

/**
 * Use the interceptor
 * 
 */

httpClient.interceptors.request.use(authInterceptor)

export default httpClient
